import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Form, Card, Col, Row } from '_zari/core'

import * as PlantillaContabilidadService from 'services/plantillaContabilidad.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CrearEditarPlantillaSection = ({ editarData, refrescarTabla, refrescarSection, origen }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      origen: origen,
      descripcion: editarData.descripcion || '',
      cuentaContableSoles: editarData.cuentaContableSoles || '',
      cuentaContableSolesInfo: editarData.cuentaContableSolesInfo || '',
      cuentaContableDolares: editarData.cuentaContableDolares || '',
      cuentaContableDolaresInfo: editarData.cuentaContableDolaresInfo || '',
      cuentaContableEuros: editarData.cuentaContableEuros || '',
      cuentaContableEurosInfo: editarData.cuentaContableEurosInfo || ''
    }),
    [editarData, origen]
  )

  const submitHandler = React.useCallback(
    data => {
      const promiseAction = editarData._id
        ? () => PlantillaContabilidadService.actualizarxId(editarData._id, data)
        : () => PlantillaContabilidadService.nuevo(data)

      promiseAction()
        .then(() => {
          __zariContext.toast(
            'success',
            editarData._id ? 'La plantilla se ha actualizado.' : 'La plantilla se ha creado.'
          )
          refrescarTabla()
          refrescarSection()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [__zariContext, editarData, refrescarTabla, refrescarSection]
  )

  return (
    <Card>
      <Card.Header>{editarData._id ? 'Editar Plantilla' : 'Nuevo Plantilla'}</Card.Header>
      <Card.Body>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
            <Form>
              <FormGroups.DescripcionFormGroup
                iError={errors.descripcion}
                iTouched={touched.descripcion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CuentaContableSolesFormGroup
                iError={errors.cuentaContableSoles}
                iTouched={touched.cuentaContableSoles}
                iValue={values.cuentaContableSolesInfo}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <FormGroups.CuentaContableDolaresFormGroup
                iError={errors.cuentaContableDolares}
                iTouched={touched.cuentaContableDolares}
                iValue={values.cuentaContableDolaresInfo}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <FormGroups.CuentaContableEurosFormGroup
                iError={errors.cuentaContableEuros}
                iTouched={touched.cuentaContableEuros}
                iValue={values.cuentaContableEurosInfo}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
              <Row className='mt-2'>
                <Col md={12} className='text-right'>
                  <Button color='secondary' onClick={refrescarSection}>
                    Cancelar
                  </Button>
                  <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  )
}

export default React.memo(CrearEditarPlantillaSection)
